<template>
  <div class="text-black">
    <p
      v-if="!item.product_variants"
      class="text-center text-black h-[90px] flex items-center justify-center"
    >
      -
    </p>
    <ul
      v-else
      class="mb-0 list-disc ml-[16px]"
    >
      <li
        v-for="(variant, variantIndex) in firstThreeVariants"
        :key="`${index}-${variantIndex}`"
      >
        {{ variant.product_name }}
      </li>
    </ul>
    <b-collapse
      :id="`collapse-${String(item.product_id)}-${index}`"
      v-model="collapsed"
    >
      <ul class="mb-0 list-disc ml-[16px]">
        <li
          v-for="(variant, variantIndex) in remainingVariants"
          :key="`${index}-${variantIndex}`"
        >
          {{ variant.product_name }}
        </li>
      </ul>
    </b-collapse>
    <b-button
      v-if="item.product_variants && item.product_variants.length > 3"
      v-b-toggle="`collapse-${String(item.product_id)}-${index}`"
      size="sm"
      variant="ghost"
      class="!flex items-center gap-[4px] px-0 mt-[8px] w-[110px]"
    >
      <span
        class="k-arrow-down-1"
        :class="{ 'rotate-180': collapsed }"
      />
      {{ collapseText }}
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'VariantList',
  props: {
    item: {
      type: Object,
      required: false,
      default: () => undefined,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      collapsed: false,
    }
  },
  computed: {
    collapseText() {
      if (!this.item || !this.item.product_variants) {
        return ''
      }
      if (this.item.product_variants.length > 3 && !this.collapsed) {
        return 'Lihat Semua'
      }
      return 'Tutup'
    },
    firstThreeVariants() {
      if (!this.item.product_variants) {
        return []
      }
      if (this.item.product_variants.length <= 3) {
        return this.item.product_variants
      }
      return this.item.product_variants.slice(0, 3)
    },
    remainingVariants() {
      if (!this.item.product_variants || this.item.product_variants.length <= 3) {
        return []
      }
      return this.item.product_variants.slice(3, this.item.product_variants.length)
    },
  },
}
</script>
